import { lazy, Suspense } from 'react';

import AccountVerification from 'features/customerPanel/accountVerification/container';
import { TransactionsLoader } from 'shared/components/loader/transactionsLoader';
import { SectionNavigation } from 'shared/constants/common';
import useSectionNavigation from 'shared/hooks/useSectionNavigation';
import { isMobile } from 'shared/util/utility';
import { Coupons } from '../../../asyncComponent';

const CpBonusDesktop = lazy(() => import('features/customerPanel/cpBonus/container/cpBonusDesktop'));
const CpChangePassword = lazy(() => import('features/customerPanel/cpChangePassword'));
const CpPersonalData = lazy(() => import('features/customerPanel/cpPersonalData/container/cpPersonalData'));
const CpPayout = lazy(() => import('features/customerPanel/cpPayout/container/cpPayout'));
const MessagesInbox = lazy(() => import('features/customerPanel/cpMessages/container/MessagesInbox'));
const CpPromoCode = lazy(() => import('features/customerPanel/cpPromoCode/container/cpPromoCode'));
const CpSettings = lazy(() => import('features/customerPanel/cpSettings'));
const CpMarketingConsent = lazy(() => import('features/customerPanel/cpMarketingConsent'));
const CpActivities = lazy(() => import('features/customerPanel/cpActivities/container/cpActivities'));
const ActivityHistory = lazy(() => import('features/customerPanel/cpActivityHistory'));
const CpTransactions = lazy(() => import('features/customerPanel/cpTransactions/container/cpTransactions'));
const CpRegulations = lazy(() => import('features/customerPanel/cpRegulations/container/cpRegulations'));
const CpLimits = lazy(() => import('features/customerPanel/cpLimits/container/cpLimits'));
const CouponWithBets = lazy(() => import('features/coupon/container/couponWithBets'));

const RenderComponents = () => {
	const { isViewActive, changeNavigationView } = useSectionNavigation();

	return (
		<>
			{isViewActive(SectionNavigation.ACCOUNT_VERIFICATION) && <AccountVerification />}

			{isViewActive(SectionNavigation.CP_PAYOUT) && isMobile() && (
				<Suspense fallback={<></>}>
					<CpPayout
						handleNavTab={(navType: any) => {
							changeNavigationView(navType);
						}}
					/>
				</Suspense>
			)}

			{isViewActive(SectionNavigation.CP_DEPOSIT) && isMobile() && <Suspense fallback={<></>} />}
			{isViewActive(SectionNavigation.CP_PERSONAL_DATA) && (
				<Suspense fallback={<></>}>
					<CpPersonalData />
				</Suspense>
			)}

			{isViewActive(SectionNavigation.CP_CHANGE_PASSWORD) && (
				<Suspense fallback={<></>}>
					<CpChangePassword />
				</Suspense>
			)}

			{isViewActive(SectionNavigation.CP_BONUS) && (
				<Suspense fallback={<></>}>
					<CpBonusDesktop />
				</Suspense>
			)}

			{isViewActive(SectionNavigation.CP_MESSAGES) && (
				<Suspense fallback={<></>}>
					<MessagesInbox mobileVersion />
				</Suspense>
			)}

			{isViewActive(SectionNavigation.CP_COUPON) && (
				<Suspense fallback={<TransactionsLoader className={'pt--50'} />}>
					<Coupons />
				</Suspense>
			)}

			{isViewActive(SectionNavigation.CP_PROMO_CODE) && (
				<Suspense fallback={<></>}>
					<CpPromoCode />
				</Suspense>
			)}

			{isViewActive(SectionNavigation.CP_SETTINGS) && (
				<Suspense fallback={<></>}>
					<CpSettings />
				</Suspense>
			)}

			{isViewActive(SectionNavigation.CP_MARKETING_CONSENT) && (
				<Suspense fallback={<></>}>
					<CpMarketingConsent />
				</Suspense>
			)}

			{isViewActive(SectionNavigation.CP_ACTIVITIES) && (
				<Suspense fallback={<></>}>
					<CpActivities />
				</Suspense>
			)}

			{isViewActive(SectionNavigation.CP_ACTIVITY_HISTORY) && (
				<Suspense fallback={<></>}>
					<ActivityHistory />
				</Suspense>
			)}

			{isViewActive(SectionNavigation.CP_TRANSACTIONS) && (
				<Suspense fallback={<></>}>
					<CpTransactions />
				</Suspense>
			)}

			{isViewActive(SectionNavigation.CP_REGULATIONS) && (
				<Suspense fallback={<></>}>
					<CpRegulations
						handleNavTab={(navType: any) => {
							changeNavigationView(navType);
						}}
					/>
				</Suspense>
			)}

			{isViewActive(SectionNavigation.CP_RESPONSIBLE_GAME) && (
				<Suspense fallback={<></>}>
					<CpLimits />
				</Suspense>
			)}

			{isViewActive(SectionNavigation.COUPON, true) && (
				<Suspense fallback={<></>}>
					<CouponWithBets changeNavigationView={changeNavigationView} />
				</Suspense>
			)}
		</>
	);
};

export default RenderComponents;
